import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import s from './NameEditor.module.scss';

export default class NameEditor extends Component {
    static propTypes = {
        name: PropTypes.string,
        onChange: PropTypes.func,
    };

    static defaultProps = { onChange: () => {} };

    constructor(props) {
        super(props);
        this.state = { editing: false, currentName: this.props.name };
    }

    onTextChange = event => {
        this.setState({ currentName: event.target.value });
    };

    onSave = () => {
        if (this.state.currentName === this.props.name) {
            this.onCancel();
        } else {
            // TODO: some kind of validation?
            this.props.onChange(this.state.currentName);
            this.setState({ editing: false });
        }
    };

    onCancel = () => {
        this.setState({ currentName: this.props.name, editing: false });
    };

    renderIcons() {
        return this.state.editing ? (
            <div className={s.icons}>
                <span className={classNames(s.icon, 'icon-tick')} onClick={this.onSave} />
                <span className={classNames(s.icon, 'icon-close')} onClick={this.onCancel} />
            </div>
        ) : (
            <div className={s.icons}>
                <span className={classNames(s.icon, 'icon-mapnote')} onClick={() => this.setState({ editing: true })} />
            </div>
        );
    }

    render() {
        const { name } = this.props;
        const { editing } = this.state;

        return (
            <div className={classNames(s.nameEditor, { [s.editing]: editing })}>
                {!editing && <div className={s.title}>{name}</div>}
                {editing && <input className={s.input} type="text" value={this.state.currentName} onChange={this.onTextChange} />}
                {this.renderIcons()}
            </div>
        );
    }
}
